// App-wide constants: cookie name, API keys (from .env at build time),
// the sub-zone color palette and the column definitions for CSV export.
export const APP_NAME = "geofix";
// Name of the cookie holding the JWT — shared by request.js and the auth slice.
export const TOKEN_NAME = "_geofix_session";

// sessionStorage key set by request.js when the API rejects our token, read by
// the sign-in form to explain WHY the user is suddenly looking at a login page
// (GF-50). It has to survive a full page load, which rules out Redux state.
// sessionStorage rather than localStorage so the message cannot outlive the tab
// it belongs to — note that it IS copied into a tab opened from this one, which
// is harmless here since the cookie is gone in that tab too.
export const SESSION_EXPIRED_KEY = "session_expired";

export const REACT_APP_GOOGLE_API = process.env.REACT_APP_GOOGLE_API;
export const REACT_APP_MAPBOX_ACCESS_TOKEN =
  process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export const PAGE_SIZE = 10;

export const DATE_FORMAT_FRONTEND = "DD MMM, YYYY";
export const DATETIME_FORMAT_FRONTEND = "DD MMM, YYYY hh:mm A";
export const DATE_FORMAT_BACKEND = "YYYY/MM/DD";
export const COLOR_DEFAULT = "ffc444";
// Palette offered when creating sub-zones (hex without '#'), grouped in
// rows of 8 as shown in the color picker.
export const COLORS_SUBZONE = [
  "ed8f8f",
  "f284a8",
  "c788d2",
  "aa92d6",
  "959ed5",
  "85c3f8",
  "76cef9",
  "75c4bc",

  "cd2929",
  "d21a55",
  "8321a0",
  "532fa8",
  "1c7de1",
  "0790e1",
  "00a2b9",
  "007e70",

  "ae1a1a",
  "7d1046",
  "411481",
  "2b1a87",
  "0f3e97",
  "044d90",
  "005559",
  "004438",

  "9bd09d",
  "bddd9b",
  "e2eb91",
  "fff392",
  "ffc575",
  "ffa186",
  "d1c5c1",
  "c8d2d7",

  "3b963e",
  "71aa3a",
  "b8c32d",
  "fdd22f",
  "fa8100",
  "f2471c",
  "826358",
  "859aa4",

  "1a531d",
  "2d5e1c",
  "776c17",
  "f37417",
  "e24700",
  "b72f0f",
  "533830",
  "3c5059",
];

// Marker icons are generated per colour at module load (see
// components/Markers/markerIcons.js), so a colour used for a marker MUST be
// listed here — otherwise the lookup yields undefined and the marker renders
// with no image, silently. 0D47A1 is the "outside the zone circle" state, see
// utils/locationStatus.js.
export const COLORS = [...COLORS_SUBZONE, "FFC444", "E53935", "00C853", "0D47A1", "d9d9d9", "888888"];

// Location fields/headers included in the CSV export (react-csv). Note the
// domain mapping: freeTextField1 is exported as "New Address".
export const ExportLocationFields = [
  'address',
  'lat',
  'lng',
  'propertyDesignation',
  'realEstateListing',
  'workOrderFlag',
  'registrationNumber',
  'freeTextField1',
  'freeTextField2',
  'owner',
  'ownerNumber',
  'adjusted',
  'type',
];

export const ExportLocationHeaders = [
  { label: "Address", key: "address" },
  { label: "Latitude", key: "lat" },
  { label: "Longitude", key: "lng" },
  { label: "Property Designation", key: "propertyDesignation" },
  { label: "Real Estate Listing", key: "realEstateListing" },
  { label: "Work Order Flag", key: "workOrderFlag" },
  { label: "Registration Number", key: "registrationNumber" },
  { label: "New Address", key: "freeTextField1" },
  { label: "Free Text Field 2", key: "freeTextField2" },
  { label: "Owner", key: "owner" },
  { label: "Owner Number", key: "ownerNumber" },
  { label: "Adjusted", key: "adjusted" },
  { label: "Type", key: "type" },
];

export const ExportSubZonesHeaders = [
  { label: "Sub Zone Name", key: "subZoneName" },
  ...ExportLocationHeaders
];
